import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxFieldWUT } from '../../../ui/checkbox-field';
export const CheckboxWUT = (props)=>{
    const fieldType = FIELD_TYPES.CHECKBOX;
    return /*#__PURE__*/ React.createElement(CheckboxFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=checkbox-wut.js.map